import { render, staticRenderFns } from "./ListRequestLetterTaghirAghsat.vue?vue&type=template&id=2784751e&scoped=true&"
import script from "./ListRequestLetterTaghirAghsat.vue?vue&type=script&lang=js&"
export * from "./ListRequestLetterTaghirAghsat.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2784751e",
  null
  
)

export default component.exports